export default __webpack_public_path__ + "static/media/done-card.7ae9c513.webp";